class modalHelper {
    constructor() {
        this.init();
    }

    init() {

        $('.video-modal').on('hidden.bs.modal', function () {
            var src = $(this).find('iframe').attr('src');
            $(this).find('iframe').attr('src', '');
            $(this).find('iframe').attr('src', src);
        });
    }
}

window.app.add('modal', new modalHelper());